export default __webpack_public_path__ + "static/airdrop-347cb8474d4833bcd816b7c32cb38d31.png";